import { ResendPasswordsDto } from '../dtos/resend-passwords.dto';
import { ResendPasswords } from '../models/resend-passwords';

/**
 * Map from model to dto.
 * @param {ResendPasswords} data Model data.
 * @returns {ResendPasswordsDto}
 */
function toDto(data) {
  return new ResendPasswordsDto({
    user_ids: data.userIds,
  });
}

export const resendPasswordsDtoMapper = {
  toDto,
};
